define('../src/sublayouts/m27-price-table-sec/m27-price-table-sec',['jquery', 'lib/utils', 'mask', 'spinner'], function ($, utils, Mask, Spinner) {
    'use strict';

    var M27_TABLE_SEC = function ($component) {

        this.$component = $component;

        return this;
    };

    M27_TABLE_SEC.prototype.init = function () {
        var _this = this,
            col = _this.$component.find('.m27-price-table-sec-col'),
            colTitle = col.find('.cell.title'),
            itemTitle = _this.$component.find('.m27-price-table-sec-title'),
            valCol = _this.$component.find('.m27-price-table-sec-val'),
            itemTitleCell = itemTitle.find('.cell'),
            itemCell = col.find('.cell'),
            headToTop = _this.$component.offset().top,
            elementHeight = _this.$component.height(),
            scrollTitle = col.find('.scrolled');

            _this.getHeight(itemTitleCell,valCol)
            _this.getHeightTitle(colTitle)
            _this.fix(scrollTitle, headToTop,_this.$component)
            
            $(window).on('orientationchange resize', function () {
                _this.getHeight(itemTitleCell,valCol)
                _this.getHeightTitle(colTitle)
                _this.setWidth()
            });
            itemCell.mouseover(function(){
                if(!$(this).hasClass('title')){
                    _this.onhover($(this),col)
                }
            })
            itemCell.mouseout(function(){
                if(!$(this).hasClass('title')){
                    _this.out($(this),col)
                }
            })
            $(window).scroll(function () {
                _this.fix(scrollTitle, headToTop,_this.$component)
            })

    };

    M27_TABLE_SEC.prototype.getHeight = function ($titleCell,$valCol) {
            var height,
                idn;
            $titleCell.each(function(i){
                height = $(this).outerHeight();
                idn = $(this).data('id');
                $valCol.find('[data-id="'+idn+'"]:not(.title)').css('height',height)
            })
    };
    M27_TABLE_SEC.prototype.getHeightTitle = function ($colTitle) {
        var maxarr = [],
            height,
            maxHeight;
        $colTitle.each(function(i){
            height = $(this).outerHeight();
            maxarr.push(height)
        })
        maxHeight = Math.max.apply(Math,maxarr);
        $colTitle.css('height',maxHeight)
   };  

    M27_TABLE_SEC.prototype.onhover = function ($cell,$valCol) {
        var thisId = $cell.data('id');
        $valCol.find('[data-id="'+thisId+'"]').addClass('hover')
    };
    M27_TABLE_SEC.prototype.out = function ($cell,$valCol) {
        var thisId = $cell.data('id');
        $valCol.find('[data-id="'+thisId+'"]').removeClass('hover')
    };
    M27_TABLE_SEC.prototype.fix = function ($element, toTop, elem) {
        var _this = this,
            winScroll = $(window).scrollTop() + 91,
            elemBottom = elem.height() + toTop - 180;

        if (winScroll > toTop && winScroll < elemBottom) {
            $element.ea
            $element.css({ 'position': 'fixed', 'top': '88px' });
            $element.addClass('fixed');
            $element.removeClass('hidden')
            _this.setWidth()
        } else {
            $element.css({ 'position': 'static', 'top': '0px' });
            $element.removeClass('fixed')
            $element.addClass('hidden')
        }
    };

    M27_TABLE_SEC.prototype.setWidth = function () {
        var calWidth = $('.m27-price-table-sec-title').width(),
            scrollCell = $('.m27-price-table-sec-title').find('.scrolled');
        if(scrollCell.hasClass('fixed')){
            scrollCell.css('width',calWidth)
        }

    }


    return M27_TABLE_SEC;

});

